import React, { useEffect, useState } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Drawer from '@material-ui/core/Drawer';
import UserInfo from 'components/UserInfo';
import {COLLAPSED_DRAWER, FIXED_DRAWER, HORIZONTAL_NAVIGATION} from 'constants/ActionTypes';
import {toggleCollapsedNav} from 'actions/Setting';
import SideBarContent from "./SideBarContent";

const SideBar = () => {
  const dispatch = useDispatch();
  const {navCollapsed, drawerType, navigationStyle} = useSelector(({settings}) => settings);
  const [drawerStyle, setDrawerStyle] = useState('');
  const [drawerVariant, setDrawerVariant] = useState('permanent');
  const [underTabletWidth, setUnderTabletWidth] = useState(false);

  // keep track of app width for sidebar
  useEffect(() => {
    const watchQuery = window.matchMedia('(max-width: 1200px)');
    let watchTimer;
    // set initial value
    setUnderTabletWidth(watchQuery.matches);

    const watchResizeDebounce = () => {
      clearTimeout(watchTimer);
      watchTimer = setTimeout(() => {
        setUnderTabletWidth(watchQuery.matches);
      }, 50);
    }

    window.addEventListener('resize', watchResizeDebounce);

    return () => {
      window.removeEventListener('resize', watchResizeDebounce);
    }
  }, []);

  // update DrawerStyle && DrawerVariant as necessary
  useEffect(() => {
    // drawerStyle
    if (navigationStyle === HORIZONTAL_NAVIGATION) {
      setDrawerStyle('');
    }
    else if (drawerType.includes(FIXED_DRAWER)) {
      setDrawerStyle('d-xl-flex');
    }
    else if (drawerType.includes(COLLAPSED_DRAWER)) {
      setDrawerStyle('d-flex');
    }

    // drawerVariant
    if (drawerType === COLLAPSED_DRAWER || 
       (drawerType === FIXED_DRAWER && underTabletWidth) ||
       navigationStyle === HORIZONTAL_NAVIGATION) {
      setDrawerVariant('temporary');
    }
    else {
      setDrawerVariant('permanent');
    }
  }, [drawerType, navigationStyle, underTabletWidth])

  const onToggleCollapsedNav = (e) => {
    dispatch(toggleCollapsedNav());
  };

  return (
    <div className={`app-sidebar d-none ${drawerStyle}`}>
      <Drawer className="app-sidebar-content"
              variant={drawerVariant}
              open={drawerVariant === 'temporary' ? navCollapsed : true}
              onClose={onToggleCollapsedNav}
              classes={{
                paper: 'side-nav',
              }}
      >
        <UserInfo/>
        {/* <SideBarContent/> */}
      </Drawer>
    </div>
  );
};

export default withRouter(SideBar);
